import React from 'react';
import './privacy-policy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-content">
        <h1>Політика конфіденційності</h1>

        <section className="policy-section">
          <h2>ЗАГАЛЬНІ ПОЛОЖЕННЯ</h2>
          <p>
            З метою забезпечення належної якості обслуговування та захисту персональних даних користувачів повідомляємо, які саме дані ми збираємо та як їх використовуємо на сайті https://skincabinet.netlify.app (далі – Сайт).
          </p>
          <p>
            Ця Політика конфіденційності не поширюється на сторонні вебсайти, перехід на які здійснюється за допомогою гіперпосилань, розміщених на Сайті.
          </p>
          <p>
            Ми обробляємо виключно ті персональні дані, які користувач надає добровільно під час використання функціоналу Сайту.
          </p>
        </section>

        <section className="policy-section">
          <h2>УМОВИ, ЦІЛІ ТА ПІДСТАВИ ОБРОБКИ ПЕРСОНАЛЬНИХ ДАНИХ</h2>
          <p>
            Персональні дані користувача, зокрема ім'я, номер телефону та інші контактні дані, надаються користувачем добровільно та за власною ініціативою.
          </p>
          <p>
            Передача персональних даних через форми зворотного зв'язку або інші інтерактивні елементи Сайту означає згоду користувача на їх обробку відповідно до цієї Політики.
          </p>
          <p>
            Обробка персональних даних здійснюється з метою надання інформації та послуг, представлених на Сайті, зв'язку з користувачем, запису на процедури та консультації, а також інформування про зміни, новини та послуги.
          </p>
        </section>

        <section className="policy-section">
          <h2>ПЕРЕДАЧА ПЕРСОНАЛЬНИХ ДАНИХ ТРЕТІМ ОСОБАМ</h2>
          <p>Ми не передаємо персональні дані третім особам, за винятком таких випадків:</p>
          <ul>
            <li>надання користувачем однозначної згоди;</li>
            <li>необхідності виконання зобов'язань перед користувачем;</li>
            <li>вимог чинного законодавства України;</li>
            <li>законних вимог уповноважених державних органів.</li>
          </ul>
          <p>
            В інших випадках персональні дані користувачів не розголошуються.
          </p>
        </section>

        <section className="policy-section">
          <h2>ТЕРМІН ЗБЕРІГАННЯ ПЕРСОНАЛЬНИХ ДАНИХ</h2>
          <p>
            Згода користувача на обробку персональних даних діє протягом невизначеного строку.
          </p>
          <p>
            Персональні дані зберігаються не довше, ніж це необхідно для досягнення цілей, визначених цією Політикою, або до моменту відкликання згоди користувачем.
          </p>
        </section>

        <section className="policy-section">
          <h2>ПРАВА КОРИСТУВАЧА</h2>
          <p>Користувач має право:</p>
          <ul>
            <li>отримувати інформацію про свої персональні дані;</li>
            <li>вимагати уточнення або виправлення персональних даних;</li>
            <li>вимагати видалення персональних даних;</li>
            <li>відкликати згоду на обробку персональних даних у будь-який час.</li>
          </ul>
          <p>
            Для реалізації зазначених прав користувач може звернутися до нас із письмовим зверненням на електронну адресу: <a href="mailto:1one.imons@gmail.com">1one.imons@gmail.com</a>
          </p>
        </section>

        <section className="policy-section">
          <h2>ЗАХИСТ ПЕРСОНАЛЬНИХ ДАНИХ</h2>
          <p>
            Ми вживаємо необхідних організаційних заходів для захисту персональних даних від несанкціонованого доступу, втрати або розповсюдження.
          </p>
        </section>

        <section className="policy-section">
          <h2>ЗМІНИ ДО ПОЛІТИКИ КОНФІДЕНЦІЙНОСТІ</h2>
          <p>
            Ми залишаємо за собою право змінювати умови цієї Політики. Усі зміни набирають чинності з моменту їх публікації на Сайті.
          </p>
          <p>
            Продовжуючи користування Сайтом, користувач підтверджує згоду з чинною редакцією Політики конфіденційності.
          </p>
        </section>

        <section className="policy-section">
          <h2>КОНТАКТНА ІНФОРМАЦІЯ</h2>
          <p>
            Якщо у вас виникнуть будь-які питання щодо нашої Політики, ви можете звернутися до нас за електронною адресою: <a href="mailto:1one.imons@gmail.com">1one.imons@gmail.com</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
